import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import moment from 'moment';
import PropTypes from 'prop-types';
import { createRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import AppModal from 'src/components/modal';
import { useGetAssigneesMutation } from 'src/services/Utils';
import {
  useCreateTicketMutation,
  useGetCodelistValueCodeAPIQuery,
  useGetPersonnelTicketMutation,
  useGetSysAdminNewCodelistQuery
} from 'src/services/workarea';
import { AppState } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import forms from '../../../resources/forms.json';
import staticData from '../../../resources/static.json';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import SitePersonnelData from './SitePersonnelData';
import { useUtil } from 'src/components/hooks/useUtil';

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};
type UserAccessRequestModalProps = {
  open: boolean;
  setOpen: any;
  studyId: any;
  setReqBtnText: any;
  selectedPersonnals?: any;
  setSelectedPersonnals?: any;
};

export default function UserAccessRequestModal({
  setReqBtnText,
  studyId,
  open,
  setOpen,
  selectedPersonnals,
  setSelectedPersonnals
}: UserAccessRequestModalProps) {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  //New Code
  const [codes, setCodes] = useState<any>({});
  const formGroup = forms.user_access_request;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups, codes);
  const { groups } = formFields;
  const formRef: any = createRef();
  const studyId1: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedsitepersonnel = useSelector((state: AppState) => state.selectedsitepersonnel);
  const [secondPopup, setSecondPopup] = useState(false);
  const { user } = useUser();
  const [didCreateTicket, { isLoading, isSuccess, data: ticketData, isError, error }] = useCreateTicketMutation();
  const sponsor = useAppSelector(state => state.site?.userAccessData.sponsor.value);
  const { handleError } = useUtil();
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();
  useEffect(() => {
    let tempData = { ...codes };
    if (!tempData.SPDC) {
      tempData = {
        ...tempData,
        SPDC: SitePersonnelData.categories.map((item: any) => {
          return { displayName: item.name, key: item.name };
        })
      };
    }
    if (!tempData.SPDP) {
      tempData = {
        ...tempData,
        SPDP: SitePersonnelData.priorities.map((item: any) => {
          return { displayName: item.title, key: item.title };
        })
      };
    }
    if (!tempData.SPONSOR && sponsor) {
      tempData = {
        ...tempData,
        SPONSOR: [
          {
            code: sponsor,
            displayName: sponsor,
            key: sponsor
          }
        ]
      };
    }
    if (!tempData.STUDY) {
      tempData = {
        ...tempData,
        STUDY: [
          {
            code: studyId,
            displayName: studyId,
            key: studyId
          }
        ]
      };
    }
    if (!tempData.COUNTRY) {
      tempData = {
        ...tempData,
        COUNTRY: [
          {
            code: selectedCountry,
            displayName: selectedCountry,
            key: selectedCountry
          }
        ]
      };
    }
    if (!tempData.SITE) {
      tempData = {
        ...tempData,
        SITE: [
          {
            code: selectedSite,
            displayName: selectedSite,
            key: selectedSite
          }
        ]
      };
    }
    if (JSON.stringify(tempData) !== JSON.stringify(codes)) {
      setCodes(tempData);
    }
  }, [codes]);
  const { data: RQSYS } = useGetSysAdminNewCodelistQuery('RQSYS');
  useEffect(() => {
    if (RQSYS && !codes.RQSYS) {
      const tempRQSYS: any = RQSYS;
      setCodes({
        ...codes,
        RQSYS: tempRQSYS.map((item: any) => {
          return { displayName: item.code_list_value, key: item.code_list_value };
        })
      });
    }
  }, [RQSYS, codes]);
  const { data: getCodeListValueData }: any = useGetCodelistValueCodeAPIQuery({
    code_list_code: 'PRJMLC',
    application: 'SYSADMIN',
    application_section: 'SYSADMIN'
  });

  useEffect(() => {
    if (getCodeListValueData && !codes.PRJMLC) {
      setCodes({
        ...codes,
        PRJMLC: getCodeListValueData.map((item: any) => {
          return { displayName: item.code_list_value, key: item.code_list_value };
        })
      });
    }
  }, [getCodeListValueData]);
  const handleSubmit = () => {
    formRef.current.submit(onFormSubmit);
  };
  const onFormSubmit = (data: any) => {
    if (data.error) {
      dispatch(setMessage({ msgDetails: 'Missing mandatory data', severity: 'error' }));
      return;
    } else if (data.success) {
      let check = false;
      if (data.records.request_system.length) {
        const firstSystem = data.records.request_system[0];
        if (staticData.SponsorApps.includes(firstSystem)) {
          data.records.request_system.forEach((element: string) => {
            if (staticData.siteApps.includes(element) && !check) {
              check = true;
            }
          });
        } else if (staticData.siteApps.includes(firstSystem)) {
          data.records.request_system.forEach((element: string) => {
            if (staticData.SponsorApps.includes(element) && !check) {
              check = true;
            }
          });
        }
      }
      if (check) {
        dispatch(
          setMessage({
            msgDetails:
              'Please select either Site (Core FICS, TSDA, ISF) or Sponsor (CTMS, TMF) applications, both Site and Sponsor applications cannot be selected for the same user.',
            severity: 'error'
          })
        );
        return;
      }
      const payload: any = {
        ...data.records,
        request_details_due_date: new Date(data.records.request_details_due_date)?.toLocaleDateString('en-CA'),
        request_system: data.records.request_system.join(','),
        status: 'Open',
        request_status: 'Open',
        created_by: user
      };
      const reqPayload: any = {
        request_details: payload,
        personnel_ids: selectedPersonnals
      };
      didCreateTicket({ data: reqPayload, study_id: studyId1, site_id: selectedSite, country: selectedCountry });
    }
  };
  const handelChange = (key: any, value: any) => {
    if (key === 'request_category') {
      const permission = SitePersonnelData.categories.find((item: any) => item.key === value)?.permission;
      if (permission) {
        getAssignees({ client_name: 'sysadmin-ui', data: [permission] });
      }
    }
    if (key === 'request_system' && value.length) {
      let check = false;
      const firstSystem = value[0];
      if (staticData.SponsorApps.includes(firstSystem)) {
        value.forEach((element: string) => {
          if (staticData.siteApps.includes(element) && !check) {
            check = true;
          }
        });
      } else if (staticData.siteApps.includes(firstSystem)) {
        value.forEach((element: string) => {
          if (staticData.SponsorApps.includes(element) && !check) {
            check = true;
          }
        });
      }
      if (check) {
        dispatch(
          setMessage({
            msgDetails:
              'Please select either Site (Core FICS, TSDA, ISF) or Sponsor (CTMS, TMF) applications, both Site and Sponsor applications cannot be selected for the same user.',
            severity: 'error'
          })
        );
      }
    }
  };

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = [];
      assignees.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name}`,
          displayName: `${item.first_name} ${item.last_name}`
        })
      );
      if (!codes.PERMISSIONASSINEE || JSON.stringify(codes.PERMISSIONASSINEE) !== JSON.stringify(assignList)) {
        setCodes({ ...codes, PERMISSIONASSINEE: assignList });
      }
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError, codes]);

  //End
  const [userReqRes, setUserReqRes] = useState<any>({});
  const defaultReqObj = {
    request_category: '',
    request_dueDate: null,
    request_priority: '',
    request_to: '',
    request_system: '',
    request_project: '',
    request_sponsor: sponsor,
    request_study: studyId,
    request_country: selectedCountry,
    request_site: selectedSite,
    request_message: '',
    request_id: ''
  };
  const [userRequestObj, setUserRequestObj] = useState<any>({ ...defaultReqObj });

  const handleCloseSecondPopup = async () => {
    setSecondPopup(false);
    setUserRequestObj({ ...userRequestObj, request_id: userReqRes.display_request_id });
    await setSelectedPersonnals([]);
  };

  const handleClose = (message: string) => {
    if (message === 'next-popup') {
      setSecondPopup(true);
    }
    setOpen(false);
    setUserRequestObj({ ...defaultReqObj });
  };

  const { checkPermission } = usePermissionWrapper();

  const { sciRequestSendSuccessMsg } = useFieldTranslation();
  const dispatch = useAppDispatch();

  const [getPersonelTicket] = useGetPersonnelTicketMutation();

  const getData = async (_: any) => {
    try {
      const reqPayload: any = {
        personnel_ids: selectedsitepersonnel.selectedsitepersonnel
      };

      const result: any = await getPersonelTicket({
        data: reqPayload,
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry
      });
      if (result?.data?.length) {
        const resultObjData = result.data[0]?.ticket_data;
        const resSetObj = {
          request_category: resultObjData.request_category,
          request_dueDate: resultObjData.request_details_due_date,
          request_priority: resultObjData.request_priority,
          request_to: resultObjData.request_assignee,
          request_system: resultObjData.request_system,
          request_sponsor: sponsor,
          request_message: resultObjData.request_details_description,
          request_id: resultObjData.request_id
        };

        setUserRequestObj({ ...userRequestObj, ...resSetObj });
        setReqBtnText('REQUESTED');
      }
    } catch (e: any) {
      const newDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
      const changedDate = newDate?.toLocaleDateString('en-CA');
      const resSetObj = {
        request_category: '',
        request_dueDate: changedDate,
        request_priority: '',
        request_to: '',
        request_system: '',
        request_sponsor: sponsor,
        request_message: '',
        request_id: ''
      };
      setUserRequestObj({ ...userRequestObj, ...resSetObj });

      setReqBtnText('REQUEST ACCESS');
      if (e.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (e.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    if (
      selectedsitepersonnel.selectedsitepersonnel !== '' &&
      selectedsitepersonnel.selectedsitepersonnel != null &&
      checkPermission('request_site_access') &&
      !checkPermission('delete_sitepersonnel')
    ) {
      if (selectedsitepersonnel.selectedsitepersonnel.length > 0) {
        getData('');
      }
    }
  }, [selectedsitepersonnel.selectedsitepersonnel]);

  useEffect(() => {
    if (!isLoading && isError) {
      handleError(error, true);
    } else if (!isLoading && isSuccess && ticketData) {
      setUserReqRes(ticketData);
      setUserRequestObj({ ...userRequestObj, request_id: userReqRes.display_request_id });
      dispatch(setMessage({ msgDetails: sciRequestSendSuccessMsg, severity: 'success' }));
      setOpen(false);
      setSecondPopup(true);
      setReqBtnText('REQUESTED');
    }
  }, [isLoading, isSuccess, ticketData, isError, error]);
  return (
    <Box>
      <AppModal
        open={open}
        title={'User Access Request'}
        handleSubmit={handleSubmit}
        handleClose={() => {
          setUserRequestObj({ ...userRequestObj, request_dueDate: null });
          handleClose('close');
        }}
      >
        <FormLayoutBuilder
          initialValues={{
            ...defaultValues,
            sponsor,
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            request_details_due_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
          }}
          rules={rules}
          ref={formRef}
          groups={groups}
          columnSpacing={2}
          onChange={(key: any, value: any) => handelChange(key, value)}
          dateFormat={userPreferedDateFormat}
        />
      </AppModal>
      <PopupComponent aria-labelledby="customized-dialog-title" onClose={handleCloseSecondPopup} open={secondPopup}>
        <DialogTitle id="alert-dialog-title">User Access Request</DialogTitle>
        <DialogContent className="request-access-modal">
          <Grid md={12} spacing={2}>
            <Grid container className="request-info">
              <Grid md={12}>
                {' '}
                <strong> Request Created: </strong>
                {moment(userReqRes.created_on).format(userPreferedDateFormat.toUpperCase())}
              </Grid>
              <Grid md={12}>
                {' '}
                <strong> Request Sent To: </strong>
                {userReqRes.request_assignee}
              </Grid>
              <Grid md={12}>
                {' '}
                <strong> Request ID: </strong>
                {userReqRes.display_request_id}
              </Grid>
              <Grid md={12}>
                {' '}
                <strong> Priority: </strong>
                {/* {userReqRes.request_priority} */}
                {userReqRes.request_priority}
              </Grid>
              <Grid md={12}>
                {' '}
                <strong> Requested By: </strong>
                {user}
              </Grid>
              <Grid md={12}>
                {' '}
                <strong> System: </strong>
                {userReqRes.request_system}
              </Grid>
              {/* <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="success">Request successfully sent.</Alert>
              </Stack> */}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus sx={{ forntSize: 14 }} onClick={handleCloseSecondPopup}>
            OK
          </Button>
        </DialogActions>
      </PopupComponent>
    </Box>
  );
}
